import { useMemo } from 'react';

const { useTranslation } = require('next-i18next');

const useLocationCMSData = () => {
  const { t } = useTranslation('');

  const data = useMemo(
    () => ({
      data: {
        LocationPage: {
          heroBackground: {
            small_url: {
              url: '/imgs/Rebranding/logos/Default_Cover_SM.jpg',
            },
            medium_url: {
              url: '/imgs/Rebranding/logos/Default_Cover_SM.jpg',
            },
            large_url: {
              url: '/imgs/Rebranding/logos/Default_Cover_LG.jpg',
            },
            xlarge_url: {
              url: '/imgs/Rebranding/logos/Default_Cover_LG.jpg',
            },
            alt: 'Location Page Background',
          },
          heroTitle: t('locationV2_page:hero_title'),
          heroSubtitle: t('locationV2_page:hero_subtitle'),
          tourTitle: t('locationV2_page:tour_title'),
          tourSubtitle: t('locationV2_page:tour_subtitle'),
          tourAction: t('locationV2_page:tour_action'),
          bookToday: t('locationV2_page:book_today'),
          tab1: t('locationV2_page:tab_1'),
          tab2: t('locationV2_page:tab_2'),
          tab3: t('locationV2_page:tab_3'),
          tab4: t('locationV2_page:tab_4'),
          tab5: t('locationV2_page:tab_5'),
          aboutTitle: t('locationV2_page:about_location'),
          DealTitle: t('locationV2_page:deals_title'),
          DealSubtitle: t('locationV2_page:deals_subTitle'),
          DealsBtn: t('locationV2_page:deals_btn'),
          motorcycleRentalsTitle: t('locationV2_page:rentals_title'),
          motorcycleRentalsSubtitle: t('locationV2_page:rentals_subTitle'),
          motorcycleRentalsAction: t('locationV2_page:rentals_btn'),
          eventsAndRidesTitle: t('locationV2_page:events_rides_title'),
          eventsAndRidesSubtitleHasCountInLocation: t(
            'locationV2_page:rides_events_count_in_location',
          ),
          ridesSubtitleHasCountInLocation: t(
            'locationV2_page:rides_found_in_location',
          ),
          eventsSubtitleHasCountInLocation: t(
            'locationV2_page:events_found_in_location',
          ),
          event: t('locationV2_page:event'),
          events: t('locationV2_page:events'),
          ride: t('locationV2_page:ride'),
          rides: t('locationV2_page:rides'),
          mapTitle: t('locationV2_page:map_title'),
          mapSubtitle: t('locationV2_page:map_subTitle'),
          dealerMapSubtitle: t('locationV2_page:dealer_map_subTitle'),
          address: t('locationV2_page:address'),
          hours: t('locationV2_page:hours'),
          parking_luggage: t('locationV2_page:parking_luggage'),
          call_us: t('locationV2_page:call_us'),
          international: t('locationV2_page:international'),
          note: t('locationV2_page:note'),
          operationTime: t('locationV2_page:operation_time'),
          showMap: t('locationV2_page:show_map'),
        },
        RentalsCardComponent: {
          startingAt: t('common_rentals_card:start_at'),
          viewBikeSpecs: t('common_rentals_card:view_bike_specs'),
        },
        DealCardComponent: {
          off: t('common_deal_card:off'),
          offAmount: t('common_deal_card:off_amount'),
          day: t('common_deal_card:day'),
          bego: t('common_deal_card:bego'),
          oneWaySpecial: t('common_deal_card:one_way_special'),
          buyXDaysGetYDaysFreeLabel: t(
            'common_deal_card:buy_x_days_get_y_days_free',
          ),
          dealDaySingular: t('common_deal_card:deal_day', { count: 1 }),
          dealDayPlural: t('common_deal_card:deal_day', { count: 2 }),
        },
        ExpandableSectionComponent: {
          expandText: t('common_expandable_description:expand'),
          collapseText: t('common_expandable_description:collapse'),
        },
        TourCardComponent: {
          dayCount: t('common_tour_card:days'),
          miCount: t('common_tour_card:mi'),
          startingAt: t('common_tour_card:start_at'),
          pricingTermsLabel: t('common_tour_card:pricing_terms_label'),
        },
        PricingTermsOverlayComponent: {
          pricingTermsHeading: t('common_pricing_terms_overlay:pricing_terms'),
          pricingTermsDescription: t(
            'common_pricing_terms_overlay:pricing_terms_text',
          ),
        },
        MainWidgetComponent: {
          firstTabText: t('common_main_widget_v2:rent'),
          secondTabText: t('common_main_widget_v2:tour'),
          errorsText: t('common_main_widget_v2:error'),
          warningText: t('common_main_widget_v2:warning'),
        },
        RentalWidgetComponent: {
          closedAlertText: t('common_rental_widget_v2:closed_alert'),
          warningNote: t('common_rental_widget_v2:warning_note'),
          changeBillingCardMessage: t(
            'fe_er_credit_cards_page:change_billing_card_msg',
          ),
          checkButtonText: t('common_rental_widget_v2:check_availability'),
          pickupLocationLabel: t('common_rental_widget_v2:pickup_loc'),
          pickupLocationPlaceholder: t('common_rental_widget_v2:choose_loc'),
          dropoffLocationLabel: t('common_rental_widget_v2:dropoff_loc'),
          dropoffLocationPlaceholder: t('common_rental_widget_v2:choose_loc'),
          pickupDateLabelMobile: t('common_rental_widget_v2:pickup_date'),
          pickupDateLabelDesktop: t('common_rental_widget_v2:date'),
          timeFieldLabel: t('common_rental_widget_v2:time'),
          dropoffDateLabelMobile: t('common_rental_widget_v2:dropoff_date'),
          dropoffDateLabelDesktop: t('common_rental_widget_v2:date'),
          milesAwayText: t('common_rental_widget_v2:miles_away'),
          ridersFieldLabel: t('common_rental_widget_v2:riders'),
          motorcycleMenuHeader: t(
            'common_rental_widget_v2:select_number_motorcycles',
          ),
          motorcycleTextSingular: t('common_rental_widget_v2:motorcycle'),
          motorcycleTextPlural: t('common_rental_widget_v2:motorcycles'),
          menuDiscountText: t('common_rental_widget_v2:off_value'),
          menuMotorcycleCountText: t('common_rental_widget_v2:motorcycle_s'),
          menuOverlayButtonText: t('common_rental_widget_v2:done'),
        },
        TourWidgetComponent: {
          allToursText: t('common_tour_widget_v2:all_moto_tours'),
          guidedToursText: t('common_tour_widget_v2:guided_moto_tours'),
          selfDriveToursText: t(
            'common_tour_widget_v2:self_drive_motorcycle_tours',
          ),
          tourTypeFieldLabel: t('common_tour_widget_v2:tour_type'),
          countryFieldLabel: t('common_tour_widget_v2:country'),
          countriesFieldPlaceholder: t('common_tour_widget_v2:all_countries'),
          stateNameFieldLabel: t('common_tour_widget_v2:state_name'),
          statesFieldPlaceholder: t('common_tour_widget_v2:all_states'),
          checkAvailabilityButtonText: t(
            'common_tour_widget_v2:check_availability',
          ),
        },
        EventRideCardComponent: {
          featuredLabel: t('common_event_ride_card:featured'),
          learnMoreBtnLabel: t('common_event_ride_card:learn_more'),
        },
      },
    }),
    [],
  );

  return data;
};

export { useLocationCMSData };
